module.exports = __webpack_public_path__ + "img/20160410_2141.50144609.jpg";